import OurLocationsContent from "$lib/data/generated/content/our locations/data.json";

import { uploads as OurLocationsUploads } from "$lib/data/generated/uploads/our locations/uploads";

const content = {
	["our locations"]: OurLocationsContent
};
const uploads = {
	...OurLocationsUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
